// A root-path cookie shares the 24-hour dismissal across the US and international sites.
const banner = document.querySelector('[data-site-banner]');

if (banner) {
  const cookieName = 'xds_banner_dismissed';
  const dismissalSeconds = 24 * 60 * 60;
  const root = document.documentElement;
  const cookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith(`${cookieName}=`));
  const dismissedUntil = cookie ? Number(cookie.split('=')[1]) : 0;
  let expiryTimer;

  const updateBannerHeight = () => {
    root.style.setProperty('--xds-banner-height', `${banner.hidden ? 0 : banner.getBoundingClientRect().height}px`);
  };

  const showAfterExpiry = (until) => {
    window.clearTimeout(expiryTimer);
    if (until > Date.now()) {
      expiryTimer = window.setTimeout(() => {
        banner.hidden = false;
        updateBannerHeight();
      }, until - Date.now());
    }
  };

  banner.hidden = dismissedUntil > Date.now();
  showAfterExpiry(dismissedUntil);
  updateBannerHeight();
  new ResizeObserver(updateBannerHeight).observe(banner);

  banner.querySelector('[data-banner-dismiss]').addEventListener('click', () => {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    const until = Date.now() + dismissalSeconds * 1000;
    document.cookie = `${cookieName}=${until}; Max-Age=${dismissalSeconds}; Path=/; SameSite=Lax${secure}`;
    banner.hidden = true;
    updateBannerHeight();
    showAfterExpiry(until);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Sticky Header
  const header = document.querySelector('.site-header');
  const scrollThreshold = 1;

  function updateHeaderClass() {
    if (window.scrollY > scrollThreshold) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  }

  // Check on page load
  updateHeaderClass();

  // Check on scroll
  document.addEventListener("scroll", updateHeaderClass);

  // Mobile Menu
  document.querySelector(".hamburger").addEventListener("click", function () {
    document.body.classList.toggle("menu-active");
    this.classList.toggle("is-active");
  });

  document.querySelectorAll(".subnav .current-item, .subnav__icon").forEach(item => {
    item.addEventListener("click", function () {
      document.querySelector(".subnav nav").classList.toggle("expanded");
    });
  });

  const navLinks = document.querySelectorAll(".nav-link");
  const menu = document.querySelector(".main-menu-mobile"); // Adjust selector for your menu
  const menuToggle = document.querySelector(".navbar-toggler"); // Adjust selector for your menu button
  const body = document.body;

  navLinks.forEach(link => {
    if (!link.classList.contains('dropdown-toggle')) {
      link.addEventListener("click", function () {
        const href = link.getAttribute("href");
        const currentUrl = window.location.origin + window.location.pathname; // Get the current URL without hash

        menu.classList.remove("show");
        body.classList.remove("menu-active");

        if (menuToggle) {
          menuToggle.classList.remove("collapse");
          menuToggle.classList.remove("is-active");
          menuToggle.classList.add("collapsed");
        }
      });
    }
  });
});

